module.exports = __webpack_public_path__ + "img/5.4e778f82.png";